import { Component, OnInit, ViewChild } from '@angular/core';
import { ToolRequestHistory } from "@models/tool-request-history.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { RequestHistoryService } from "@services/request-history.service";
import { HttpResponse } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { Log } from 'ng2-logger';
import { ToolRequestsService } from '@app/core/services/tool-requests.service';
import { ToolRequest } from '@app/shared/models/toolRequests.model';
import { PendingToolRequestsModalComponent } from '@app/shared/pages/pending-tool-requests-modal/pending-tool-requests-modal.component';
import * as _ from "lodash";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-tool-request-history',
    templateUrl: './tool-request-history.component.html',
    styleUrls: ['./tool-request-history.component.scss']
})
export class ToolRequestHistoryComponent implements OnInit {

    _logger = Log.create(ToolRequestHistoryComponent.name);

    @ViewChild(PendingToolRequestsModalComponent, {static: true}) requestModalComponent: PendingToolRequestsModalComponent;

    toolRequestHistory: ToolRequestHistory[] = [];

    tableConfig = new TableConfig();

    requestConfig = new TableConfig();

    tableFilters = [];
    reportFilters = [];

    isLoadingRequestsHistory = false;
    isLoadingDownload: boolean;

    selectedToolRequest: ToolRequest = new ToolRequest();

    public toolName: string;
    public toolUid: string;
    onNameChanged = _.debounce(this.nameChanged, 300);
    onUidChanged = _.debounce(this.uidChanged, 300);

    constructor(private requestHistoryService: RequestHistoryService, private toolRequestsService: ToolRequestsService,
                private toastr: ToastsManager, private translationService: TranslateService) {
    }

    ngOnInit() {
        this.tableConfig.sorter = {
            field: 'createdDate',
            IsSortingAscending: false
        };
        this.getRequestsHistory(this.tableConfig);
    }

    onFilterChange(tableFilters: any = [], reportFilters: any = []) {
        this.tableFilters = tableFilters;
        this.reportFilters = reportFilters;

        this.tableConfig.filters = this.reportFilters.concat(this.tableFilters);

        this.getRequestsHistory(this.tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.getRequestsHistory(tableConfig);
    }

    getRequestsHistory(tableConfig = this.tableConfig) {
        this.isLoadingRequestsHistory = true;
        this.tableConfig = tableConfig;
        this.requestHistoryService.getRequestHistory(tableConfig).subscribe(data => {
                this.toolRequestHistory = data.toolRequestHistory;
                this.tableConfig.pager.count = data.count;
                this.isLoadingRequestsHistory = false;
            },
            (error: any) => {
                this.isLoadingRequestsHistory = false;
            });
    }

    onRequestsHistoryDownload(tableConfig = this.tableConfig) {
        this.isLoadingDownload = true;
        this.requestHistoryService.downloadRequestHistoryReport(tableConfig).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    const blob = new Blob([data.body], {type: 'application/xsls'});
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
                this.isLoadingDownload = false;
            },
            (error: any) => {
                this.isLoadingDownload = false;
                this.toastr.error(this.translationService.instant('Server_Error'));
            });
    }

    onPageChange(tableConfig: TableConfig) {
        this.tableFilters = tableConfig.filters;
        tableConfig.filters = _.union(this.reportFilters, this.tableFilters);
        this.getRequestsHistory(tableConfig);
    }

    onTableRowClick(request: ToolRequestHistory) {
        this.getToolRequestHistory(request);
    }

    uidChanged() {
        this.tableConfig.filters = this.reportFilters;
        const name = 'toolUid';
        this.tableConfig.removeFilter(name);
        this.tableConfig.upsertFilter(name, this.toolUid);
        this.getRequestsHistory();
    }

    nameChanged() {
        this.tableConfig.filters = this.reportFilters;
        const name = "toolName";
        this.tableConfig.removeFilter(name);
        this.tableConfig.upsertFilter(name, this.toolName);
        this.getRequestsHistory();
    }

    private getToolRequestHistory(request: ToolRequestHistory) {
        this.isLoadingRequestsHistory = true;
        this.toolRequestsService.getToolRequestDetails(request.toolRequestId).subscribe(
            (details: ToolRequest) => {
                this._logger.info('getToolRequestDetails:: API Returned data', details);
                this.selectedToolRequest = details;
                this.requestModalComponent.open(this.selectedToolRequest)
                this.isLoadingRequestsHistory = false;
            },
            (error) => {
                this._logger.info('getToolRequestDetails:: API Returned error', error);
            }
        )
    }
}
